import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  standalone: false,
  selector: "app-mawingu-redirect",
  templateUrl: "./mawingu-redirect.component.html",
  styleUrls: ["./mawingu-redirect.component.scss"],
})
export class MawinguRedirectComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    const phoneNumber = this.route.snapshot.queryParamMap.get("phoneNumber");
    this.router.navigate(["/login"], { queryParams: { phoneNumber } });
  }
}
